import { jsx as _jsx } from "react/jsx-runtime";
import { VisibleColumnType } from "@air/api/types";
import { memo } from "react";
import { KanbanFetchPageProvider } from "~/components/KanbanView/KanbanColumnsManagers/shared/KanbanFetchPageContext";
import { useKanbanContext } from "~/components/KanbanView/Providers/KanbanProvider";
import { KanbanColumnContainer } from "~/components/KanbanView/shared/KanbanColumnContainer";
import { KANBAN_COL_GUTTER } from "~/components/KanbanView/shared/kanbanConstants";
import { kanbanColumnItemsSelector } from "~/store/kanbanManager/selectors";
import { useAirSelector } from "~/utils/ReduxUtils";
import { KanbanColumnHeader } from "../shared/KanbanColumnHeader";
import { KanbanColumnItems } from "../shared/KanbanColumnItems/KanbanColumnItems";
export const DndDragKanbanColumn = /*#__PURE__*/ memo((param)=>{
    let { draggedColumnData } = param;
    const kanbanItems = useAirSelector((state)=>kanbanColumnItemsSelector(state, (draggedColumnData === null || draggedColumnData === void 0 ? void 0 : draggedColumnData.kanbanColumnId) || ""));
    const { customFieldValues } = useKanbanContext();
    const headerProps = {
        itemCount: kanbanItems.length,
        id: "".concat(draggedColumnData.kanbanColumnId, "-dragging"),
        label: "None",
        color: "transparent"
    };
    if (draggedColumnData.kanbanColumnId !== VisibleColumnType.unassignedCustomFieldValue) {
        const cfValue = customFieldValues === null || customFieldValues === void 0 ? void 0 : customFieldValues.find((cfVal)=>cfVal.id === draggedColumnData.kanbanColumnId);
        if (cfValue) {
            headerProps.label = cfValue.value;
            headerProps.color = cfValue.color.name;
            headerProps.itemCount = kanbanItems.length;
        }
    }
    return /*#__PURE__*/ _jsx("div", {
        className: "pointer-events-none h-[70vh] origin-top scale-[0.6] px-[KANBAN_COL_GUTTER/2]",
        style: {
            paddingLeft: KANBAN_COL_GUTTER / 2,
            paddingRight: KANBAN_COL_GUTTER / 2
        },
        children: /*#__PURE__*/ _jsx(KanbanFetchPageProvider, {
            children: /*#__PURE__*/ _jsx(KanbanColumnContainer, {
                header: /*#__PURE__*/ _jsx("div", {
                    className: "mb-4 max-w-[60%] origin-top-left scale-[1.6]",
                    children: /*#__PURE__*/ _jsx(KanbanColumnHeader, {
                        ...headerProps
                    })
                }),
                children: /*#__PURE__*/ _jsx(KanbanColumnItems, {
                    kanbanColumnId: draggedColumnData.kanbanColumnId
                })
            })
        })
    });
});
DndDragKanbanColumn.displayName = "DndDragKanbanColumn";
